<div
  class="full-page w-100 d-flex align-items-center justify-content-center px-0"
  [style.background-image]="'url(' + ('login-registration/login-banner-image.png' | contentAssetImage) + ')'"
>
  <div class="maintenance-panel bg-white rounded-4 text-center p-4 d-flex flex-column gap-5">
    <div class="d-flex justify-content-center align-items-center">
      <div><img [src]="'login-registration/fortress-login.svg' | contentAssetImage" class="logo" /></div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <h5
        class="text-primary text-center"
        [innerHTML]="'maintenancepage.currentlyunavailable.text' | translate | markdownTranslate"
      ></h5>
    </div>
  </div>
</div>
